var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymousUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.5106 30.4938C55.4273 44.2791 44.6041 55.1119 31.2621 55.5023C17.0544 55.9178 5.58246 44.5875 5.49076 30.6591C5.39906 16.9197 16.3625 5.61029 30.2298 5.48664C44.2387 5.3616 55.437 16.496 55.512 30.4938H55.5106ZM48.436 42.6146C54.256 34.3187 53.6044 21.506 44.3054 13.7686C35.1745 6.17159 21.4809 7.44008 13.87 16.6015C6.54668 25.4171 8.17918 36.7376 12.6279 42.5854C22.434 32.6112 38.6771 32.5987 48.4346 42.6146H48.436Z",
    fill: "#60646E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.5152 22.1617C40.5277 27.6385 36.029 32.1512 30.5535 32.1554C25.0419 32.1595 20.5181 27.6955 20.507 22.2437C20.4959 16.6167 24.9474 12.1513 30.5743 12.1458C36.0304 12.1402 40.5027 16.6473 40.5152 22.1631V22.1617Z",
    fill: "#60646E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousUser);
export default __webpack_public_path__ + "static/media/anonymous_user.9229c9ee7ed58d3bc0bfa185f92f047d.svg";
export { ForwardRef as ReactComponent };